import { useContext, useEffect, useState } from "react";
import { AppContext } from "../State/Context";
import { ActionType } from "../State/State";
import { isMobile } from "../utils/settings";
import discord from "./discord.png";
import { PlayBtn } from "./PlayBtn";
import { showSystemMessage } from "../api/api";
import { getHexLoaderStats } from "../World/hexImageLoader";

export const MenuBottom = () => {
  const { state, dispatch } = useContext(AppContext);
  const [animatedText, setAnimatedText] = useState("Join us on");
  const [previousPoints, setPreviousPoints] = useState<number | null>(null);
  const [previousSparks, setPreviousSparks] = useState<number | null>(null);
  const [hexLoaderStats, setHexLoaderStats] = useState<{ queue: number; active: number; rejected: number } | null>(null);
  const isAdmin = state.player?.role === "admin";

  useEffect(() => {
    if (!isAdmin) return;
    const interval = setInterval(() => setHexLoaderStats(getHexLoaderStats()), 500);
    return () => clearInterval(interval);
  }, [isAdmin]);

  const clickOnPlayer = async () => {
    const uid = state.player?.uid;
    if (uid) {
      dispatch({ type: ActionType.SELECT_PLAYER, uid });
      dispatch({ type: ActionType.TOGGLE_PLAYER_INFO_POPUP });
    }
  };

  // Анимация текста "Join us on"
  useEffect(() => {
    const frames = [
      ">oin us on",
      ">>in us on",
      ">>>n us on",
      "J>>> us on",
      "Jo>>>us on",
      "Joi>>>s on",
      "Join>>> on",
      "Join >>>on",
      "Join u>>>n",
      "Join us>>>",
      "Join us >>",
      "Join us o>",
      "Join us on",
    ];
    let currentFrame = 0;

    const intervalId = setInterval(() => {
      setAnimatedText(frames[currentFrame]);
      currentFrame = (currentFrame + 1) % frames.length;
    }, 250);

    return () => clearInterval(intervalId);
  }, []);

  // Track points changes and show system message
  useEffect(() => {
    if (state.player?.points !== undefined) {
      if (previousPoints === null) {
        setPreviousPoints(state.player.points);
      } else if (previousPoints !== state.player.points) {
        const diff = state.player.points - previousPoints;
        showSystemMessage({
          systemMessage: diff > 0 ? "success" : "error",
          text: `${diff > 0 ? "⚡️ +" : ""}${diff} ⚡️ Points`,
        });
        setPreviousPoints(state.player.points);
      }
    }
  }, [state.player?.points, previousPoints]);

  useEffect(() => {
    if (state.player?.sparks !== undefined) {
      if (previousSparks === null) {
        setPreviousSparks(state.player.sparks);
      } else if (previousSparks !== state.player.sparks) {
        const diff = state.player.sparks - previousSparks;
        showSystemMessage({
          systemMessage: diff > 0 ? "success" : "error",
          text: `${diff > 0 ? "🌟 +" : ""}${diff} 🌟 Sparks`,
        });
        setPreviousSparks(state.player.sparks);
      }
    }
  }, [state.player?.sparks, previousSparks]);

  return (
    <div className="fixed bottom-0 left-0 right-0 p-3 z-[1000000000] [transform:translateZ(0)]">
      <div className="text-sm select-none absolute bottom-0 left-0 right-0 p-2 bg-[antiquewhite] flex justify-between items-center">
        <div className="flex items-center gap-4">
          {state.player ? (
          <div className="relative inline-block">
            <span
              onClick={clickOnPlayer}
              className="font-bold underline cursor-pointer"
            >
              {state.player.name}
            </span>
            <span className="no-underline text-xs ml-2 mr-2">
              {state.player.points}⚡️  {state.player.sparks}🌟
            </span>
            {!isMobile() && <PlayBtn />}
          </div>
        ) : (
          <div></div>
        )}
          {isAdmin && hexLoaderStats !== null && (
            <span className="text-xs text-gray-600" title="Hex loader: queue / loading / rejected">
              Hex: q={hexLoaderStats.queue} load={hexLoaderStats.active} rej={hexLoaderStats.rejected}
            </span>
          )}
        </div>
        <div className="text-xs">
          {animatedText}{" "}
          <a
            href="https://discord.gg/yqkuuXnt2N"
            target="_blank"
            rel="noreferrer"
            className="text-xs cursor-pointer select-none"
          >
            <img
              src={discord}
              alt=""
              width={20}
              className="inline-block mr-1 mt-[-3px]"
            />
            discord
          </a>
        </div>
      </div>
    </div>
  );
};
